import { ReactNode } from 'react'
import { css } from '@emotion/react'

import useOrganization from '../services/useOrganization'
import { Breakpoints } from '../theme/Responsive'
import Footer from './Footer'
import Topbar from './Topbar'

export default function RootLayout(props: { children: ReactNode }) {
  const organization = useOrganization()
  return (
    <div
      css={css`
        /* Do not let <body> to have a scrollbar as it does not go well with <PopupLayer> */
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          padding: 20px;
          margin: 0 auto;
          max-width: 1280px;
          min-height: 100vh;
          box-sizing: border-box;
          @media (max-width: ${Breakpoints.TabletLandscape}px) {
            padding: 20px 40px;
          }

          @media (max-width: ${Breakpoints.Mobile}px) {
            padding: 15px;
          }
        `}
      >
        <Topbar
          organization={organization}
          css={css`
            margin-bottom: 20px;
          `}
        />

        <div
          css={css`
            flex: 1 0 auto;
            display: flex;
            flex-direction: column;

            > * {
              flex: 1 0 auto;
            }
          `}
          role="main"
        >
          {props.children}
        </div>

        <div
          css={css`
            text-align: center;
            margin-top: 20px;
          `}
        >
          <Footer organization={organization} />
        </div>
      </div>
    </div>
  )
}
